import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { UserService } from '../../shared/services/user.service';
import { first } from 'rxjs/operators';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PortalProfile } from './user-profile.model';
import { Country } from '../../shared/models/country.model';
import { LookupService } from '../../shared/services/lookup.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
//import { SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';
import { PortalUserService } from '../../services/e-booking/shared/services/portal-user.service';
import { RegistrationType } from '../../shared/models/register-type.model';
import { PortalUserType } from '../../shared/models/portal-user-type.model';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  profileForm: FormGroup;
  user: User = new User();
  portalProfile: PortalProfile = new PortalProfile();
  loading = false;
  submitted = false;
  responseObject: ResponseObject;
  Countries: Country[];
  userID: string = '';
  isReadOnly: boolean = false;
  displayedLang: any;
  public Languages: any = Languages;
  numberRegex: string = '^[0-9]*$';
  showRequest = false;
  // SearchCountryField = SearchCountryField;
  //TooltipLabel = TooltipLabel;
  isConfirmed: boolean = false;

  emailRegex: string = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';
  registrationTypes: RegistrationType[] = [];
  portalUserTypes: PortalUserType[] = [];
  isErrorMessage: boolean= false;
  showConfirmMail: boolean=false;

  constructor(
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private alertService: AlertService,
    private lookupService: LookupService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private globalSrv: GlobalServices,
    private portalSrv: PortalUserService
  ) {
    this.user = this.authenticationService.currentUserValue;
    this.userID = this.activatedRoute.snapshot.queryParams.UserID;
    this.buildForm();
    this.displayedLang = this.globalSrv.getLanguage();

  }


  ngOnInit() {
    if (this.userID) {
      this.getPortalUser(this.userID);
    }
    else {
      this.getPortalUser(this.user.UserId);
    }
    this.getLookups();
    this.isReadOnly = this.userID ? true : false;
    this.userID ? this.profileForm.disable() : null;
  }

  get f() {
    return this.profileForm.controls;
  }
  getPortalUser(userId: string) {
    this.portalSrv.GetPortalUser(userId)
      .subscribe((data: ResponseObject) => {

        this.portalProfile.UserId = userId;
        this.portalProfile.FullName = data.Data['FullName'];
        this.portalProfile.UserName = data.Data['UserName'];
        this.portalProfile.Email = data.Data['Email'];
        this.portalProfile.Address = data.Data['Address'];
        this.portalProfile.Organization = data.Data['Organization'];
        this.portalProfile.Fax = data.Data['Fax'];
        this.portalProfile.CountryId = data.Data['CountryId'];
        this.portalProfile.Mobile = data.Data['Mobile'];
        this.isConfirmed = data.Data['IsConfirmed'];
        this.portalProfile.RegisterTypeId = data.Data['RegisterTypeId'];
        this.portalProfile.PortalUserTypeId = data.Data['PortalUserTypeId'];

        this.profileForm.patchValue({
          email: this.portalProfile.Email,
          address:this.portalProfile.Address,
          fax: this.portalProfile.Fax,
          organization: this.portalProfile.Organization,
          fullName: this.portalProfile.FullName,
          country: this.portalProfile.CountryId,
          mobile: this.portalProfile.Mobile,
          RegisterTypeId :this.portalProfile.RegisterTypeId,
          PortalUserTypeId:this.portalProfile.PortalUserTypeId
        }
          );
      });
  }

  buildForm() {
    this.profileForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      address: [''],
      fax: ['', Validators.pattern(this.numberRegex)],
      organization: [''],
      fullName: ['', Validators.required],
      country: ['', Validators.required],
      mobile: ['', Validators.required],
      RegisterTypeId :[''],
      PortalUserTypeId:['']
    });
  }

  getLookups() {
    this.lookupService.getCountries()
      .subscribe((data: ResponseObject) => {
        this.Countries = data.Data as Country[];
      });
    this.lookupService.getRegistrationType()
      .subscribe((data: ResponseObject) => {
        this.registrationTypes = data.Data as RegistrationType[];
      });

    this.lookupService.getPortalUserType()
      .subscribe((data: ResponseObject) => {
        this.portalUserTypes = data.Data as PortalUserType[];
      });
  }


  onSubmit() {
    this.submitted = true;
    if (this.isConfirmed) {
      this.profileForm.patchValue({
        email: this.portalProfile.Email
      });

    } else {
      this.portalProfile.Email = this.profileForm.controls.email.value;
      this.showConfirmMail= true;
    }
    // stop here if form is invalid
    if (this.profileForm.invalid) {
      return;
    }

    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.portalProfile.FullName = this.profileForm.controls.fullName.value;
    this.portalProfile.Mobile = this.profileForm.controls.mobile.value;
    this.portalProfile.Address = this.profileForm.controls.address.value;
    this.portalProfile.Fax = this.profileForm.controls.fax.value;
    this.portalProfile.Organization = this.profileForm.controls.organization.value;

    this.portalProfile.CountryId = this.profileForm.controls.country.value;

    this.alertService.clear();
    this.userService.CompleteAccount(this.portalProfile)
      .pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          this.responseObject = data;
          if (this.responseObject.Success) {
            this.responseObject.Data.UserName = this.user.UserName;
            localStorage.setItem('currentUser', JSON.stringify(this.responseObject.Data));
            this.authenticationService.currentUserSubject.next(this.responseObject.Data);

            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.COMPLETE_ACCOUNT'), false);
            //this.router.navigate(['/workspace']);
            //this.globalSrv.goToHome();
            this.loading = false;
            this.isErrorMessage= false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage= true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]), false);
            this.loading = false;
          }

        });
  }
}
